import { Images } from "../../Assets/Index";
import { dispatchtoast, getLocalStorageItem } from "../../Utils";
import { Button, Image, Input, message } from "antd";
import { IoCaretBack } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useCommmonStore } from "../../Store/CommonReducer";
import { getProfile } from "../Profile/UserEndpoints";
import { BiCopy } from "react-icons/bi";

const Share = () => {
  const navigate = useNavigate();
  const [referralCode, setReferralCode] = useState("");
  const { profileDetail, setProfileDetail } = useCommmonStore();
  const accessToken = getLocalStorageItem("accessToken");
  const UserProfile = () => {
    getProfile()
      .then((res) => {
        if (res.status) {
          setProfileDetail(res.data);
        }
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    UserProfile();
  }, []);
  const handleCopy = () => {
    const code = profileDetail?.user?.referral_code;
    if (code) {
      navigator.clipboard?.writeText(code);

      dispatchtoast("Referral code copied!", false);
    }
  };
  return (
    <>
      <div className="flex justify-center pb-20 items-center bg-black rounded-lg">
        <div className="w-full ">
          <div className="flex justify-between bg-gradient-to-r from-[#734e0c] via-[#ba7d13] to-[#e9a52f] px-8  py-2 gap-x-3 items-center ">
            <div className="text-white font-semibold flex  items-center gap-4 ">
              <IoCaretBack
                className="bg-[#ba7d13] h-7 w-7 rounded-lg cursor-pointer text-white"
                onClick={() => navigate("/home")}
              />
              <p className="text-xl font-normal custome">
                {getLocalStorageItem("userDetails")?.name}Share App
              </p>
            </div>
            <div className="flex justify-between items-center">
              <img src={Images.Money} className="w-8 m-auto my-2" alt="money" />
              <p className="text-white text-sm  custome">
                ₹ {profileDetail?.user?.wallet_balance ?? 0}
              </p>
            </div>
          </div>

          <div className="h-[100vh] bg-black ">
            <div className="text-center ">
              <Image
                preview={false}
                width={200}
                height={200}
                src={Images.Logo}
                alt="logo"
              />
            </div>
            {/* <div
              className="gap-2 bg-gray-600
                  items-center rounded-lg m-4 p-2  border-none"
            >
              <div className="shadow-sm m-2 text-center">
                <p className="text-base text-white custome font-medium ">
                  Total Commission Earned
                </p>
                <p className="text-xs mt-4 text-white custome font-normal ">
                  ₹0.00
                </p>
              </div>
            </div> */}
            <div className="gap-2 text-white custome items-center rounded-lg m-4 p-2 border-none">
              <p className="text-base text-white custome font-medium">
                REFERRAL CODE
              </p>

              <div className="gap-2">
                <Input
                  readOnly
                  value={profileDetail?.user?.referral_code || ""}
                  suffix={
                    <span
                      className="text-[#fba037] cursor-pointer flex items-center gap-1"
                      onClick={handleCopy}
                    >
                      <BiCopy />
                      Tap to Copy
                    </span>
                  }
                  className="border-dashed hover:border-[#c86d04] custom-placeholder border border-[#fba037] px-3 py-2 rounded-md w-full text-white font-semibold"
                  placeholder="Referral code"
                />

                <Button
                  onClick={() => {
                    if (accessToken) {
                      window.open("https://web.whatsapp.com/", "_blank");
                    } else {
                      navigate("/");
                    }
                  }}
                  type="default"
                  htmlType="submit"
                  className="w-[370px] m-8 custome rounded-3xl h-10 font-medium text-lg border-none text-white bg-gradient-to-r from-[#734e0c] via-[#ba7d13] to-[#e9a52f] hover:bg-gradient-to-r hover:from-[#734e0c] hover:via-[#ba7d13] hover:to-[#e9a52f]"
                >
                  Share On WhatsApp
                </Button>
              </div>
            </div>

            {/* <div
              className=" gap-2 
                  items-center  mt-6 p-2"
            >
              <div className="shadow-sm m-2 ">
                <p className="text-xs text-white custome font-medium mb-2">
                  * Earn a 3% commission when you add a friend to the game
                </p>
                <p className="text-xs text-white custome font-medium ">
                  * Receive a bonus of 100 when you invite a friend using your
                  referral code
                </p>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Share;
